import cropSamplingService from "./cropSamplingService";

const samplingCropService = [
    ...cropSamplingService
];

export default samplingCropService;